export const makeURL = (baseUrl, path) => {
  if (!/^https?:\/\//i.test(baseUrl)) {
    baseUrl = `https://${baseUrl}`;
  }

  const url = new URL(path, baseUrl);

  return url.toString();
};
